import { Routes } from "@angular/router";
import { AuthGuard } from "../../core/guards/auth-guard.service";
import { PermissionGuard } from "@core/guards/permission.guard";

export const seleccionPersonalRoutes: Routes = [
  {
    path: "sel_inicio",
    loadComponent: () =>
      import("./components/inicio/inicio.component").then(
        (m) => m.InicioSeleccionPersonalComponent,
      ),
    data: {
      label: "Inicio",
      icon: "home",
      urlexterna: "SEL",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "sel_motivo-busqueda",
    loadComponent: () =>
      import("../seleccion-personal/components/motivos-busqueda/motivos-busqueda.component").then(
        (m) => m.MotivosBusquedaComponent,
      ),
    data: {
      label: "Motivos de Búsqueda",
      icon: "search",
      urlexterna: "SEL",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "sel_motivo-busqueda/causas",
    loadComponent: () =>
      import("../seleccion-personal/components/motivos-busqueda/causas-motivo/causas-motivo.component").then(
        (m) => m.CausasMotivoComponent,
      ),
    data: {
      label: "Causas por Motivo",
      icon: "list",
      urlexterna: "SEL",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: "sel_solicitud-personal",
    loadComponent: () =>
      import("../seleccion-personal/components/solicitud-personal/solicitud-personal.component").then(
        (m) => m.SolicitudPersonalComponent,
      ),
    data: {
      label: "Solicitud de Personal",
      icon: "person_search",
      urlexterna: "SEL",
    },
    canActivate: [AuthGuard, PermissionGuard],
  },
];
